<template>
  <div class="wt2-file-component">
    <div class="-stage" @click.prevent="browse">
      <div class="-placeholder">
        <span class="wt2-text-n">
          {{ placeholder }}
        </span>
      </div>
      <div class="-favicon">
        <slot name="favicon">
          <!-- fallback content -->
          <i class="wticon wticon-dots-three-full" title="Browse"> </i>
        </slot>
      </div>
    </div>
    <input type="file" ref="file" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    placeholder: {
      type: String,
      default: 'Click and select a file',
    },
  },

  methods: {
    browse() {
      this.$refs.file.click();
    },
  },
};
</script>
